import { defineNuxtPlugin, useRuntimeConfig } from "#imports";
import { getRequestLocale } from "@backmarket/nuxt-module-i18n-locale/getRequestLocale";
import { useI18nLocale } from "@backmarket/nuxt-module-i18n-locale/useI18nLocale";
import { useMarketplace } from "@backmarket/nuxt-module-marketplace/useMarketplace";
import { isTestEnv } from "@backmarket/utils/env/isTestEnv";
import { useInjectTranslationsScriptInHead } from "./composables/useInjectTranslationsScriptInHead.js";
import { useShouldLogMissingTranslationValue } from "./composables/useShouldLogMissingTranslationValue.js";
import { useShowDefaultMessage } from "./composables/useShowDefaultMessage.js";
import { useShowTranslationKeys } from "./composables/useShowTranslationKeys.js";
import { PROCESS_KEY } from "./constants.js";
import { getI18n } from "./utils/getI18n.js";
export default defineNuxtPlugin({
  name: "i18n",
  dependsOn: ["i18nLocale"],
  setup: (nuxt) => {
    if (nuxt.ssrContext) {
      const locale2 = getRequestLocale(nuxt.ssrContext.event);
      if (!globalThis[PROCESS_KEY]) {
        throw new Error(
          "[nuxt-module-i18n] Cannot retrieve translations from the main process"
        );
      }
      if (import.meta.server) {
        const { eagerlyLoadedTranslationsRoutes = [] } = useRuntimeConfig().public.i18n;
        useInjectTranslationsScriptInHead(locale2, {
          eagerlyLoadedTranslationsRoutes
        });
      }
    }
    if (!isTestEnv() && !useI18nLocale()) {
      throw new Error("[nuxt-module-i18n] Cannot retrieve locale in useState");
    }
    const locale = useI18nLocale();
    const { market } = useMarketplace();
    const currencyCode = market.defaultCurrency;
    const showDefaultMessage = useShowDefaultMessage();
    const showTranslationKeys = useShowTranslationKeys();
    const shouldLogMissingTranslationValue = useShouldLogMissingTranslationValue();
    return {
      provide: {
        i18n: getI18n(
          locale,
          currencyCode,
          showTranslationKeys,
          showDefaultMessage,
          shouldLogMissingTranslationValue
        )
      }
    };
  }
});
